import { render, staticRenderFns } from "./FormularioPedido.vue?vue&type=template&id=048de907&scoped=true&"
import script from "./FormularioPedido.vue?vue&type=script&lang=js&"
export * from "./FormularioPedido.vue?vue&type=script&lang=js&"
import style0 from "./FormularioPedido.vue?vue&type=style&index=0&id=048de907&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048de907",
  null
  
)

export default component.exports